// extracted by mini-css-extract-plugin
module.exports = {"root":"contact-card_root__8uNUt","top":"contact-card_top__9832j","title":"contact-card_title__5r57P","icon":"contact-card_icon__1sLKo","content":"contact-card_content__KdIYN"};